exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ui-breadcrumb {\n  background: none;\n  border: none;\n  border-bottom: 1px solid #bebebe;\n  padding-bottom: 10px; }\n  .ui-breadcrumb li {\n    margin-right: 5px; }\n    .ui-breadcrumb li:last-child .ui-breadcrumb-chevron {\n      display: none; }\n\n.ui-breadcrumb-chevron::before {\n  content: \"\\F105\"; }\n\n.ui-menuitem-text {\n  font-size: 16px; }\n  .ui-menuitem-text:hover {\n    color: #767676; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /dist/src/app/ui/breadcrumbs/breadcrumbs.component.scss
// module id = ../../../../../src/app/ui/breadcrumbs/breadcrumbs.component.scss
// module chunks = main